<template>
  <li @click="dumpContext" class="wt-ready-made-preview-item no-transition">
    <div>
      <div class="wt2-poster">
        <div class="wt2-thumbnail-hover" :data-id="story.id">
          <div class="-info">
            <i v-if="story.type === 'VO'" class="wticon wticon-mic" />
            <span class="wt2-video-duration">{{ duration }}</span>
          </div>
          <i class="wticon wticon-play3"></i>
        </div>

        <div class="-inner">
          <img v-if="poster" :src="poster" />
        </div>
      </div>

      <footer class="wt-preview-item-footer">
        <div class="-top-line">
          <div
            class="wt2-timestamp wt2-text-s -divider"
            :title="story.publishedDate | timeFormat('lll', true)"
            v-text="lastUpdate"
          />
          <wt-aspect-ratio-tag :id="story.aspectRatio" />
        </div>
        <div class="-bottom-line">
          <div
            class="wt2-title"
            :title="story.title"
            v-text="story.title || 'Untitled Video'"
          />
        </div>
      </footer>
    </div>
  </li>
</template>

<script>
import app from 'app';

export default {
  name: 'ready-made-preview-item',

  props: {
    story: {
      type: Object,
      required: true,
    },
    tab: {
      type: String,
    },
    index: {
      type: Number,
    },
  },

  data: function () {
    return {};
  },

  computed: {
    poster() {
      return this.mixinSrc(this.story.thumbnailPath, this.story.posterPath);
    },
    lastUpdate() {
      const millisecondsFromNow = this.currentTime - this.story.publishedDate;
      return app.TIME.getTimeAgo(millisecondsFromNow);
    },
    duration() {
      const videoDuration = window.parseFloat(this.story.videoDuration);
      const durationMs = Math.floor(videoDuration * 1000);

      return app.moment.utc(durationMs).format('m:ss');
    },
    ...app.Vuex.mapGetters(['selectedStory']),
    ...app.Vuex.mapState(['currentTime']),
  },

  methods: Object.assign(
    {
      leave() {
        console.log('leave');
      },

      /**
       * @param e {Event}
       */
      dumpContext(e) {
        if (e.metaKey || e.ctrlKey) {
          this.$log('Story preview', this.story);
        }
      },
    },
    app.Vuex.mapMutations(['setSelectedStory'])
  ),
};
</script>
